import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Barcode from 'react-barcode';
import BackButton from './BackButton';
import { LeadsClient } from '../web-api-client.ts';

const Scan = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  // Update barcode state when the user types in the input field
  //navigate to /dvi/view/:id
  useEffect(() => {
    
    const leadClient = new LeadsClient();
    leadClient.createScan(Number(id));

    
    navigate(`/dvi/view/${id}`);
  }, [id, navigate]);

  // Trigger print dialog
  const handlePrint = () => {
    window.print(); // Trigger the print dialog
  };

  return (
    <>scan</>
   
  );
};

export default Scan;